import React from 'react';
import type { WCmsHomepageSectionView } from '@zola/svc-web-api-ts-client';

const HomepageSections = ({
  homepageSections,
}: {
  homepageSections: Array<WCmsHomepageSectionView>;
}): JSX.Element => {
  return (
    <div className="entity-sections homepage-sections clearfix">
      {homepageSections.map((homepageSection, idx) => (
        <div className="entity-section homepage-section clearfix" key={idx}>
          <div className="entity-section-title homepage-section-title">
            <h2 className="section-title">{homepageSection.title}</h2>
            {homepageSection.subtitle && (
              <h4 className="section-subtitle">{homepageSection.subtitle}</h4>
            )}
          </div>
          <div className="entity-section-description homepage-section-description-v2">
            <p>{homepageSection.description}</p>
          </div>
          <div className="section-accent" />
        </div>
      ))}
    </div>
  );
};

export default HomepageSections;
